import { mergeDeepRight } from 'ramda'
import React from 'react'

import { Column } from '@ant-design/plots'

const BarChart = ({ data, xField, yField, color, ...props }) => {
  const config = mergeDeepRight(
    {
      data,
      xField,
      yField,
      animation: false,
      tooltip: false,
      color: ({ label }) => {
        if (label === 'Média') return '#b6d7a8'
        if (label.includes('COMBATE A INCÊNDIO')) return '#ff0000'
        if (label.includes('OBJETIVO DE VULNERABILIDADE')) return '#ff0000'
        if (label.includes('CONTROLE DE ACESSO')) return '#4f81bd'
        return color
      },
      legend: true,
      yAxis: {
        max: 100,
        label: {
          formatter: value => value + '%'
        }
      },
      xAxis: {
        label: {
          style: {
            textAlign: 'right'
          },
          autoEllipsis: true,
          offset: 10,
          rotate: -45
        }
      },
      label: {
        position: 'middle',
        formatter: ({ percentage }) => percentage + '%'
      }
    },
    props
  )

  return <Column {...config} />
}

export default BarChart
